var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.section.meeting_times)?_c('div',{staticClass:"row meeting-time"},[_vm._v(_vm._s(_vm.t("helpers.label.section.meeting_times"))+": "+_vm._s(_vm.section.meeting_times))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }